import { render, staticRenderFns } from "./appWelcome.vue?vue&type=template&id=1f2e15c4&scoped=true"
import script from "./appWelcome.vue?vue&type=script&lang=js"
export * from "./appWelcome.vue?vue&type=script&lang=js"
import style0 from "./appWelcome.vue?vue&type=style&index=0&id=1f2e15c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e15c4",
  null
  
)

export default component.exports